import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { DateRangePicker, SelectField } from '@wit-support/ui';
import { CONTENT_ALL_TIME_LABEL_RU, CONTENT_CUSTOM_PERIOD_LABEL_RU, CONTENT_PERIOD_LABEL_RU, calendarDayToDate, dateToCalendarDay, } from '@wit-support/ui-domain';
import { PERIOD_PRESETS, defaultCustomBounds, periodBoundaryDay, } from './period.js';
/**
 * «Период» в строке фильтров: 7 / 28 / 90 дней, «Всё время», «Свой период».
 * Свой период выбирается календарём кита (`DateRangePicker`); дни — по
 * времени расписания движка (см. `period.ts`).
 */
export function PeriodFilter({ idPrefix, value, allowAll = true, onChange }) {
    const fromDay = value.choice === 'custom' ? periodBoundaryDay(value.from) : undefined;
    const toDay = value.choice === 'custom' ? periodBoundaryDay(value.to) : undefined;
    const range = {
        from: fromDay ? calendarDayToDate(fromDay) : undefined,
        to: toDay ? calendarDayToDate(toDay) : undefined,
    };
    return (_jsxs(_Fragment, { children: [_jsx(SelectField, { id: `${idPrefix}-period`, label: "\u041F\u0435\u0440\u0438\u043E\u0434", value: value.choice, onChange: (v) => {
                    const choice = v;
                    onChange(choice === 'custom' ? { choice, ...defaultCustomBounds() } : { choice });
                }, options: [
                    ...PERIOD_PRESETS.map((p) => ({ value: p, label: CONTENT_PERIOD_LABEL_RU[p] })),
                    ...(allowAll ? [{ value: 'all', label: CONTENT_ALL_TIME_LABEL_RU }] : []),
                    { value: 'custom', label: CONTENT_CUSTOM_PERIOD_LABEL_RU },
                ] }), value.choice === 'custom' ? (_jsxs("div", { className: "flex flex-col gap-1", children: [_jsx(DateRangePicker, { value: range, numberOfMonths: 1, placeholder: "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0434\u043D\u0438", 
                        // Только по «Применить»: иначе первый клик (react-day-picker
                        // отдаёт `{ from: d, to: d }`) менял бы адрес и данные.
                        applyMode: "confirm", onChange: (next) => {
                            // «Применить» — полный диапазон; «Сбросить» — период по умолчанию.
                            if (next.from && next.to) {
                                onChange({
                                    choice: 'custom',
                                    from: dateToCalendarDay(next.from),
                                    to: dateToCalendarDay(next.to),
                                });
                            }
                            else if (!next.from && !next.to) {
                                onChange({ choice: '28d' });
                            }
                        } }), _jsx("span", { className: "text-xs text-[var(--color-text-muted)]", children: "\u0414\u043D\u0438 \u2014 \u043F\u043E \u0432\u0440\u0435\u043C\u0435\u043D\u0438 \u0440\u0430\u0441\u043F\u0438\u0441\u0430\u043D\u0438\u044F (\u041B\u043E\u0441-\u0410\u043D\u0434\u0436\u0435\u043B\u0435\u0441)" })] })) : null] }));
}
//# sourceMappingURL=period-filter.js.map